import React, { useEffect } from "react";
import { db } from "../db";
import { ImportIndexedb, ExportIndexedb } from "../components/IndexedDBManager";
 import { useNavigate } from "react-router-dom";

function Admin() {
  const navigate = useNavigate();
  useEffect(() => {
    db.expenses
      .count()
      .then((count) => {})
      .catch((error) => {
        console.error("Error fetching total expenses count:", error);
      });
  }, []);

  return (
    <div className="container main-div">
      <div className="display-center pb-4">
        <button
          className="btn verticalAlign position-absolute start-0 "
          onClick={() => {
            navigate(-1);
          }}
        >
          <span className="fs-1  material-symbols-outlined">chevron_backward</span>
        </button>
        <h3 className=" verticalAlign heading-txt">Admin Panel </h3>
      </div>

      <div className="child-div card  setting-div">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3 ">
            <div className="mb-3">
              <label className="form-label pb-2">Export</label>
              <br />
              <button
                className="save-btn rounded-pill pt-2 pb-2 "
                onClick={ExportIndexedb}
              >
                {" "}
                <span className="material-symbols-outlined verticalAlign">
                  <span className="material-symbols-outlined">
                    share_windows
                  </span>
                </span>
                <span className="ms-1 verticalAlign"> Database </span>
              </button>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-2 ">
            <div className="mb-3  ">
              <label className="form-label pb-2">Upload </label>
              <br />{" "}
              <input
                className="btn p-0 m-0"
                type="file"
                accept="application/json"
                onChange={(event) => ImportIndexedb(event)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
